import React, { useEffect, useState } from "react";
import "./Duplicateresume.scss";
import Modal from "react-bootstrap/Modal";
import {
  resumeDuplicate,
  duplicateTitle,
} from "../../Store/Actions/ResumeActions";
import { useHistory, useParams, useRouteMatch } from "react-router";
import { useDispatch, useSelector } from "react-redux";

function Duplicateresume(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const [title, setTitle] = useState("");
  const userData = useSelector((state) => state.userData.userInfo);
  const duplicate = useSelector((state) => state.duplicateResume);
  const resume_title_count = useSelector((state) => state.duplicateTitle.data);
  const resumeTitle = useSelector((state) => state.resumeLastUpdatedAt);
  const [errors, setErrors] = useState("");
  const [rand, setRand] = useState("");

  const onChange = (e) => {
    setTitle({ title: e.target.value.trim() });
  };

  const handleDuplicate = () => {
    setRand(1);
    dispatch(
      resumeDuplicate(
        userData && userData.user && userData.user.id,
        props.resume.id,
        title
      )
    );
  };

  useEffect(() => {
    if (props.show && resumeTitle.title) {
      dispatch(duplicateTitle(resumeTitle.title));
    }
  }, [props.show]);

  useEffect(() => {
    if (resume_title_count && resume_title_count.data) {
      setTitle({ title: `${resumeTitle.title}(${resume_title_count.data})` });
    }
  }, [resume_title_count]);

  // useEffect(()=>{
  //   if(rand!==""&&resume_title_count && resume_title_count.success==false)
  //   {
  //    dispatch(resumeDuplicate(userData.id,props.resume.id,title))
  //   }

  //   if(rand!==""&&resume_title_count && resume_title_count.success==true)
  //   {
  //     setErrors(resume_title_count && resume_title_count.message);
  //   }

  // },[rand]);
  useEffect(() => {
    if (rand !== "" && duplicate && duplicate.data && duplicate.data.id) {
      history.push(
        `/resumes/${duplicate && duplicate.data && duplicate.data.id}`
      );
      props.duplicateHide();
    }
  }, [duplicate]);

  const duplicateHide = () => {
    props.duplicateHide(false);
  };
  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        keyboard={true}
        onEscapeKeyDown={props.duplicateHide}
      >
        <Modal.Body>
          <button type="button" className="close" onClick={props.duplicateHide}>
            <span aria-hidden="true">
              <img src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/close.svg`} alt="closeicon" className="close" />
            </span>
            <span className="sr-only">Close</span>
          </button>
          <div className="container">
            <div className="text-center">
              <h4 className="maintitle duplicatetitle">
                Duplicate{" "}
                {props && props.cover == "cover_letter"
                  ? "  Cover Letter"
                  : " resume"}{" "}
              </h4>
              <div className="duplicatebody">
                <label>New Name</label>
                <input
                  type="text"
                  name="title"
                  value={title.title}
                  className="form-control customform duplicateinput"
                  onChange={(e) => onChange(e)}
                />
              </div>
              {errors && errors != "" && (
                <p
                  className="error"
                  style={{ textAlign: "left", color: "red", fontSize: "12px" }}
                >
                  {errors}
                </p>
              )}
            </div>
            <div className="row">
              <div className="col-md-6">
                <button
                  onClick={() => duplicateHide()}
                  className="btn primarybtn float-right w-75 mainborder dupbtn"
                >
                  Cancel
                </button>
              </div>
              <div className="col-md-6">
                <button
                  className="btn primarybtn bgsuccess text-white p-14 w-75 dupbtn"
                  onClick={handleDuplicate}
                >
                  Save as new{" "}
                  {props && props.cover == "cover_lette"
                    ? " Cover Letter"
                    : " resume"}
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Duplicateresume;
